import * as React from "react";
import { Context } from "./_context";
export const FpoBurstIcon = ({ size = 32, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[32] = /* @__PURE__ */ React.createElement("svg", { width: "2rem", height: "2rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M17.5 26h-3v-6h3v6ZM12 17.5H6v-3h6v3Zm14 0h-6v-3h6v3ZM17.5 12h-3V6h3v6Z", fill: "currentColor" }));
  return iconset[size];
};
FpoBurstIcon.iconId = "lflGqA";
